<!-- 联盟成员的代发单列表 -->
<template>
    <div class="business-content-main trans-to-purchase-order">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button v-if="permission.printPreview" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="printPreview()">{{
                    permission.printPreview
                }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">联盟成员</div>
                <el-select
                    class="search-item"
                    size="small"
                    v-model="searchData.MemberName"
                    remote
                    filterable
                    allow-create
                    placeholder="成员名称"
                    :remote-method="searchMember"
                    v-select-scroll-more="searchMemberLoad"
                    popper-class="my-select"
                >
                    <el-option v-for="item in cusOptions" :key="item.MemberId" :label="item.EntpName" :value="item.EntpName">
                        <div class="name">
                            {{ item.EntpName }}
                        </div>
                    </el-option>
                </el-select>
                <div class="search-name">联盟单号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.UnionOrderCode" placeholder="请输入联盟单号"></el-input>
                <div class="search-name">我的销售单号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.MyOrderCode" placeholder="请输入销售单号"></el-input>
                <div class="search-name">创建日期</div>
                <el-date-picker
                    v-model="dateTimes"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="handleChange"
                    size="small"
                    class="search-name"
                    style="width: 250px"
                ></el-date-picker>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :row-key="getRowKeys"
                @selection-change="handleSelectionChange"
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                ref="multipleTable"
                border
                style="width: 100%"
            >
                <el-table-column type="selection" reserve-selection></el-table-column>
                <el-table-column width="180" prop="UnionOrderCode" label="联盟单号">
                    <template slot-scope="scope">
                        <div v-if="scope.row.State == 1" style="color: #409eff" @click="gotoUnionOrderDetail(scope.row)" type="text">
                            {{ scope.row.UnionOrderCode }}
                        </div>
                        <div v-else>{{ scope.row.UnionOrderCode }}</div>
                    </template>
                </el-table-column>
                <el-table-column width="160" prop="MyOrderCode" label="我的销售单号" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.row.State == 1" style="color: #409eff" @click="gotoMyOrderDetail(scope.row)" type="text">
                            {{ scope.row.MyOrderCode }}
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column width="160" prop="EntpCusName" label="联盟成员" show-overflow-tooltip></el-table-column>
                <el-table-column width="120" prop="PayTypeName" label="支付方式" show-overflow-tooltip></el-table-column>
                <el-table-column width="120" prop="OrderAmount" label="销售总额" show-overflow-tooltip></el-table-column>
                <el-table-column width="120" prop="ShipAmount" label="运费"></el-table-column>
                <el-table-column prop="CalcAmount" label="合计" show-overflow-tooltip></el-table-column>
                <el-table-column prop="StateName" label="订单状态" show-overflow-tooltip></el-table-column>
                <el-table-column width="90" prop="SName" label="业务员" show-overflow-tooltip></el-table-column>
                <el-table-column width="160" prop="UpdateTime" label="最后更新时间" show-overflow-tooltip></el-table-column>
                <el-table-column width="160" prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button
                                v-if="permission.confirm && !scope.row.IsCancel && scope.row.State == 5"
                                title="确认联盟订单"
                                size="mini"
                                type="text"
                                @click="gotoEditUnionOrders(scope.row, 2)"
                                >{{ permission.confirm }}</el-button
                            >
                            <el-button
                                v-if="permission.cancel && !scope.row.IsCancel && scope.row.IsCanCancel"
                                title="撤销联盟订单"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="cancelUnionOrder(scope.row.MyOrderId)"
                                >{{ permission.cancel }}</el-button
                            >
                            <el-button
                                v-if="permission.del && scope.row.IsCancel"
                                title="删除联盟订单"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="delUnionOrder(scope.row.MyOrderId)"
                                >{{ permission.del }}</el-button
                            >
                            <el-button v-if="permission.opRecords" title="操作记录" size="mini" type="text" @click="opRecords(scope.row)">{{ permission.opRecords }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="联盟订单的操作记录" :visible.sync="OrderLifesVisible" width="1000px">
            <div class="dialog-content" v-if="OrderLifesVisible">
                <OrdersLifes :OrderId="OrderId" :OrderType="7" @closeDialog="closeOrderLifesDialog"></OrdersLifes>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="dialogVisible" width="870px">
            <div class="dialog-content" v-if="dialogVisible">
                <printContent @closeDialog="closeDialog" :unionOrderId="unionOrderId"></printContent>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import OrdersLifes from '@/components/entpUnion/orderManage/unionOrdersLifes';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        OrdersLifes
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            dateTimes: '',
            searchData: {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                MyOrderCode: '',
                UnionOrderCode: '',
                StartDate: '',
                EndDate: '',
                State: '0',
                MemberName: '',
                Page: 1,
                limit: 15
            },
            tableData: [], //列表数据
            tableDataLength: 0,
            permission: {},
            orderStates: [
                { Text: '全部', Value: '-1' },
                { Text: '未采购', Value: '0' },
                { Text: '部分采购', Value: '1' },
                { Text: '已采购', Value: '2' }
            ],
            verifyStates: [
                { Text: '全部', Value: '-1' },
                { Text: '已核实', Value: '1' },
                { Text: '未核实', Value: '0' }
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            OrderLifesVisible: false,
            OrderId: '',
            multipleSelection: [],
            unionOrderId: "",
            dialogVisible: false,
        };
    },
    activated() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
    },
    mounted() {
        this.permission = this.$util.getUnionPermission('AgentOrderList');
        this.getTableData();
        this.getPrintComponents();
    },
    methods: {
        //获取销售单转采购的列表
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpUnionOrders/GetUnionMemberAgentOrders',
                    data: this.searchData,
                    hideLoading: false
                })
                .then(res => {
                    let data = res.data;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        gotoEditUnionOrders(row, type) {
            this.$router.push(`/entpUnion/unionOrdersManage/editAgentOrders_o?type=${type}&orderId=${row.MyOrderId}&entpCusId=${row.EntpCusId}&entpCusName=${row.EntpCusName}`);
        },
        gotoMyOrderDetail(row) {
            this.$router.push(`/entpUnion/unionOrdersManage/editAgentOrders_o?type=1&orderId=${row.MyOrderId}&entpCusId=${row.EntpCusId}&entpCusName=${row.EntpCusName}`);
        },
        gotoUnionOrderDetail(row) {
            this.$router.push(`/entpUnion/unionOrdersManage/editAgentOrders_o?type=3&orderId=${row.MyOrderId}`);
        },
        resetSearch() {
            this.searchData = {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                MyOrderCode: '',
                UnionOrderCode: '',
                StartDate: '',
                EndDate: '',
                State: '0',
                MemberName: '',
                Page: 1,
                limit: this.commonPageSize
            };
            this.dateTimes = [];
        },
        handleSearch() {
            this.searchData.Page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        cancelUnionOrder(orderId) {
            if (orderId) {
                let that = this;
                that.$confirm('确定要取消该联盟代发单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpUnionOrders/CancelUnionAgentOrder',
                            data: {
                                EntpCusOId: orderId,
                                UnionId: that.$util.getLocalStorage('currentUnion')
                            }
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('取消联盟代发单成功！');
                                that.getTableData();
                            }
                        });
                });
            }
        },
        // 删除联盟订单
        delUnionOrder(orderId) {
            if (orderId) {
                let that = this;

                that.$confirm('确定要删除该联盟代发单吗？', '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定继续删除',
                    cancelButtonText: '取消'
                })
                    .then(() => {
                        that.$util
                            .axiosPost({
                                url: `/api/EntpSaleOrder/DelSaleOrder?OrderId=${orderId}`,
                            })
                            .then(res => {
                                if (res.errcode == 0) {
                                    that.$util.successMsg('删除联盟代发单成功！');

                                    for (let i = 0; i < that.tableData.length; i++) {
                                        if (that.tableData[i].MyOrderId == orderId) {
                                            that.tableData.splice(i, 1);
                                            return;
                                        }
                                    }
                                }
                            })
                            .catch(() => {});
                    })
                    .catch(action => {});
            }
        },
        // 联盟成员名称列表，搜索
        async searchMember(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchUnionMember(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchMemberLoad() {
            this.cusForm.Page += 1;
            this.searchMember();
        },
        opRecords(item) {
            let id = item ? item.UnionOrderId : '';
            if (id) {
                this.OrderId = id;
                this.OrderLifesVisible = true;
            } else {
                this.$util.warningMsg('联盟订单数据异常，请刷新后重新操作');
            }
        },
        getRowKeys(row) {
            return row.UnionOrderId;
        },
        closeOrderLifesDialog() {
            this.OrderLifesVisible = false;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        printPreview() {
            let LODOP = this.$lodop.getLodop();
            if (!LODOP) return;

            if (this.multipleSelection.length == 0) {
                this.$util.warningMsg('请选择一张销售单打印');
                return;
            } else if (this.multipleSelection.length > 1) {
                this.$util.warningMsg('只能选择一张销售单打印');
                return;
            }
            if (this.multipleSelection[0].StateName == '已取消') {
                this.$util.warningMsg('不能打印已取消的销售单');
                return;
            }
            if (this.multipleSelection[0].StateName == '未提交') {
                this.$util.warningMsg('不能打印未提交的销售单');
                return;
            }
            if (this.multipleSelection[0].WarehouseType == 1) {
                this.$util.warningMsg('不能打印前置仓出仓的销售单');
                return;
            }
            this.unionOrderId = this.multipleSelection[0].UnionOrderId;
            this.dialogVisible = true;
        },
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents(8).then(data => {
                if (data) {
                    Vue.component('printContent', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printContent', () => import('@/components/printModels/printAgentSales'));
                }
            });
        },
        closeDialog() {
            this.dialogVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
.table-ctn {
    height: calc(100% - 162px);
    overflow-y: auto;
}
.search-item {
    width: 150px;
}
</style>
<style lang="less">
.trans-to-purchase-order {
    .el-table {
        .hover-row > td,
        .el-table__row:hover > td {
            background-color: #dcdee1;
        }
    }
}
</style>